// Made by Per to use in Figma https://docs.google.com/spreadsheets/d/1zMeKCCHYdnuL5FfJDqVISv_TqxbzztwNI65vizAm7oY/edit#gid=0
export const fakePeopleData = [
  {
    id: '19471212-2235',
    firstname: 'Kenth',
    lastname: 'Jansson-Rosén',
    fullname: 'Kenth Jansson-Rosén',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 27098,

    _seed: 27,
  },
  {
    id: '19881003-2386',
    firstname: 'Lina',
    lastname: 'Ekberg',
    fullname: 'Lina Ekberg',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 19491,

    _seed: 83,
  },
  {
    id: '19531103-2121',
    firstname: 'Kajsa',
    lastname: 'Högberg',
    fullname: 'Kajsa Högberg',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 9946,

    _seed: 26,
  },
  {
    id: '20000226-2384',
    firstname: 'Majken',
    lastname: 'Björk',
    fullname: 'Majken Björk',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19376,

    _seed: '',
  },
  {
    id: '19840731-9295',
    firstname: 'Tim',
    lastname: 'Åström',
    fullname: 'Tim Åström',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 14485,

    _seed: '',
  },
  {
    id: '19491117-2296',
    firstname: 'Fatima',
    lastname: 'Jonsson-Dahl',
    fullname: 'Fatima Jonsson-Dahl',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 7597,

    _seed: '',
  },
  {
    id: '19550307-1887',
    firstname: 'Jesper',
    lastname: 'Olausson',
    fullname: 'Jesper Olausson',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 25125,

    _seed: '',
  },
  {
    id: '20040719-2392',
    firstname: 'Josef',
    lastname: 'Boman',
    fullname: 'Josef Boman',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 20193,

    _seed: '',
  },
  {
    id: '19561126-2857',
    firstname: 'Jesper',
    lastname: 'Jansson',
    fullname: 'Jesper Jansson',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 21124,

    _seed: '',
  },
  {
    id: '19430613-4760',
    firstname: 'Mia',
    lastname: 'Eklund',
    fullname: 'Mia Eklund',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 18270,

    _seed: '',
  },
  {
    id: '19991230-2388',
    firstname: 'Jimmy',
    lastname: 'Henriksson',
    fullname: 'Jimmy Henriksson',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 19392,

    _seed: '',
  },
  {
    id: '19901019-2392',
    firstname: 'Caroline',
    lastname: 'Jacobsson-Henriksson',
    fullname: 'Caroline Jacobsson-Henriksson',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 26398,

    _seed: '',
  },
  {
    id: '19650509-2962',
    firstname: 'Mari',
    lastname: 'Erlandsson',
    fullname: 'Mari Erlandsson',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 26717,

    _seed: '',
  },
  {
    id: '19550307-1887',
    firstname: 'Thi',
    lastname: 'Sandström',
    fullname: 'Thi Sandström',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 26695,

    _seed: '',
  },
  {
    id: '19521031-2582',
    firstname: 'Peter',
    lastname: 'Strömberg-Hedman',
    fullname: 'Peter Strömberg-Hedman',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 25157,

    _seed: '',
  },
  {
    id: '19981224-2395',
    firstname: 'Michael',
    lastname: 'Axelsson',
    fullname: 'Michael Axelsson',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 7306,

    _seed: '',
  },
  {
    id: '19940106-2386',
    firstname: 'Pär',
    lastname: 'Hellström',
    fullname: 'Pär Hellström',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 26234,

    _seed: '',
  },
  {
    id: '19620323-3066',
    firstname: 'Lovisa',
    lastname: 'Lindblom',
    fullname: 'Lovisa Lindblom',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 25024,

    _seed: '',
  },
  {
    id: '20011217-2382',
    firstname: 'Maryam',
    lastname: 'Andersson',
    fullname: 'Maryam Andersson',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 20786,

    _seed: '',
  },
  {
    id: '19840731-9295',
    firstname: 'Dan',
    lastname: 'Martinsson',
    fullname: 'Dan Martinsson',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 8189,

    _seed: '',
  },
  {
    id: '19580607-3077',
    firstname: 'Michelle',
    lastname: 'Sandström',
    fullname: 'Michelle Sandström',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 5852,

    _seed: '',
  },
  {
    id: '19430407-4695',
    firstname: 'Björn',
    lastname: 'Lundmark',
    fullname: 'Björn Lundmark',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 26375,

    _seed: '',
  },
  {
    id: 19450912,
    firstname: 'Ewa',
    lastname: 'Carlsson',
    fullname: 'Ewa Carlsson',
    fok: '0000000350',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 9388,

    _seed: '',
  },
  {
    id: '19541112-2590',
    firstname: 'Samir',
    lastname: 'Löfgren',
    fullname: 'Samir Löfgren',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 24849,

    _seed: '',
  },
  {
    id: 19911202,
    firstname: 'Claes',
    lastname: 'Dahl',
    fullname: 'Claes Dahl',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 25330,

    _seed: '',
  },
  {
    id: '20020708-2389',
    firstname: 'Ewa',
    lastname: 'Lindén',
    fullname: 'Ewa Lindén',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 10839,

    _seed: '',
  },
  {
    id: '19541112-2590',
    firstname: 'Jennifer',
    lastname: 'Mårtensson',
    fullname: 'Jennifer Mårtensson',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 15036,

    _seed: '',
  },
  {
    id: '19840731-9295',
    firstname: 'Magnus',
    lastname: 'Ljungberg',
    fullname: 'Magnus Ljungberg',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 10783,

    _seed: '',
  },
  {
    id: '19971217-2395',
    firstname: 'Mårten',
    lastname: 'Björklund',
    fullname: 'Mårten Björklund',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 23228,

    _seed: '',
  },
  {
    id: '19820202-9289',
    firstname: 'Alex',
    lastname: 'Sköld',
    fullname: 'Alex Sköld',
    fok: '0000000350',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19221,

    _seed: '',
  },
  {
    id: '19530519-2626',
    firstname: 'Mustafa',
    lastname: 'Björkman',
    fullname: 'Mustafa Björkman',
    fok: '0000000308',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19974,

    _seed: '',
  },
  {
    id: '19631007-2993',
    firstname: 'Catarina',
    lastname: 'Lundmark',
    fullname: 'Catarina Lundmark',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 18113,

    _seed: '',
  },
  {
    id: '19541018-1969',
    firstname: 'Hilda',
    lastname: 'Skoglund',
    fullname: 'Hilda Skoglund',
    fok: '0000000350',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 6779,

    _seed: '',
  },
  {
    id: '19330404-9228',
    firstname: 'Madelene',
    lastname: 'Erlandsson',
    fullname: 'Madelene Erlandsson',
    fok: '0000000308',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 9816,

    _seed: '',
  },
  {
    id: '19470307-4684',
    firstname: 'Yvonne',
    lastname: 'Sjöberg',
    fullname: 'Yvonne Sjöberg',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 9801,

    _seed: '',
  },
  {
    id: '19821015-9284',
    firstname: 'Emil',
    lastname: 'Mårtensson',
    fullname: 'Emil Mårtensson',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 29709,

    _seed: '',
  },
  {
    id: '19390813-9060',
    firstname: 'Kalle',
    lastname: 'Ljung-Borg',
    fullname: 'Kalle Ljung-Borg',
    fok: '0000000308',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 17854,

    _seed: '',
  },
  {
    id: '19540317-2199',
    firstname: 'Mari',
    lastname: 'Jonasson',
    fullname: 'Mari Jonasson',
    fok: '0000000350',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 16616,

    _seed: '',
  },
  {
    id: '19540317-2199',
    firstname: 'Nicklas',
    lastname: 'Pedersen',
    fullname: 'Nicklas Pedersen',
    fok: '0000000308',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 21417,

    _seed: '',
  },
  {
    id: '19490810-2363',
    firstname: 'Nicole',
    lastname: 'Lindblad',
    fullname: 'Nicole Lindblad',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 21172,

    _seed: '',
  },
  {
    id: '19901104-2380',
    firstname: 'Agneta',
    lastname: 'Hedström',
    fullname: 'Agneta Hedström',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 7656,

    _seed: '',
  },
  {
    id: '19831231-9281',
    firstname: 'Sofie',
    lastname: 'Wallin',
    fullname: 'Sofie Wallin',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 28401,

    _seed: '',
  },
  {
    id: '19540317-2199',
    firstname: 'Johnny',
    lastname: 'Englund',
    fullname: 'Johnny Englund',
    fok: '0000000308',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 11796,

    _seed: '',
  },
  {
    id: '19931228-2396',
    firstname: 'Thi',
    lastname: 'Gustafsson',
    fullname: 'Thi Gustafsson',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 21650,

    _seed: '',
  },
  {
    id: '19441219-8154',
    firstname: 'Christian',
    lastname: 'Molin',
    fullname: 'Christian Molin',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19575,

    _seed: '',
  },
  {
    id: '19521031-2582',
    firstname: 'Peter',
    lastname: 'Abdi',
    fullname: 'Peter Abdi',
    fok: '0000000350',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 11030,

    _seed: '',
  },
  {
    id: '19671109-2681',
    firstname: 'Linn',
    lastname: 'Melin',
    fullname: 'Linn Melin',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 28201,

    _seed: '',
  },
  {
    id: '19831231-9281',
    firstname: 'Ronnie',
    lastname: 'Åström',
    fullname: 'Ronnie Åström',
    fok: '0000000350',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 26634,

    _seed: '',
  },
  {
    id: '19480826-2341',
    firstname: 'Lovisa',
    lastname: 'Palm',
    fullname: 'Lovisa Palm',
    fok: '0000000374',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 6862,

    _seed: '',
  },
  {
    id: '19541018-1969',
    firstname: 'Andreas',
    lastname: 'Nordström',
    fullname: 'Andreas Nordström',
    fok: '0000000308',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 8096,

    _seed: '',
  },
  {
    id: '19790709-9282',
    firstname: 'Sara',
    lastname: 'Franzén',
    fullname: 'Sara Franzén',
    fok: '0000000374',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 11496,

    _seed: '',
  },
  {
    id: '19541112-2590',
    firstname: 'Mattias',
    lastname: 'Dahl-Karlsson',
    fullname: 'Mattias Dahl-Karlsson',
    fok: '0000000350',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 24406,

    _seed: '',
  },
  {
    id: '19750330-9176',
    firstname: 'Mohamed',
    lastname: 'Lindh',
    fullname: 'Mohamed Lindh',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 17219,

    _seed: '',
  },
  {
    id: '20021026-2382',
    firstname: 'Dick',
    lastname: 'Hedlund',
    fullname: 'Dick Hedlund',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 28354,

    _seed: '',
  },
  {
    id: '20000226-2384',
    firstname: 'Tobias',
    lastname: 'Söderström',
    fullname: 'Tobias Söderström',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 22652,

    _seed: '',
  },
  {
    id: '19820202-9289',
    firstname: 'Rikard',
    lastname: 'Nordström',
    fullname: 'Rikard Nordström',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 7412,

    _seed: '',
  },
  {
    id: '19901019-2392',
    firstname: 'Olov',
    lastname: 'Boman',
    fullname: 'Olov Boman',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 28298,

    _seed: '',
  },
  {
    id: '19521031-2582',
    firstname: 'Måns',
    lastname: 'Gustafsson',
    fullname: 'Måns Gustafsson',
    fok: '0000000350',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 18508,

    _seed: '',
  },
  {
    id: '19991229-2399',
    firstname: 'Abdul',
    lastname: 'Linder',
    fullname: 'Abdul Linder',
    fok: '0000000308',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 23528,

    _seed: '',
  },
  {
    id: '19450701-8820',
    firstname: 'Dan',
    lastname: 'Ibrahim',
    fullname: 'Dan Ibrahim',
    fok: '0000000350',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 28008,

    _seed: '',
  },
  {
    id: '19541112-2590',
    firstname: 'Hussein',
    lastname: 'Lundin',
    fullname: 'Hussein Lundin',
    fok: '0000000350',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal arbetstagare på civilflygområdet',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 22925,

    _seed: '',
  },
  {
    id: '19950605-2399',
    firstname: 'My',
    lastname: 'Ivarsson',
    fullname: 'My Ivarsson',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 26011,

    _seed: '',
  },
  {
    id: 20011225,
    firstname: 'Paulina',
    lastname: 'Hedberg',
    fullname: 'Paulina Hedberg',
    fok: '0000000350',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 11920,

    _seed: '',
  },
  {
    id: '19870410-2386',
    firstname: 'Samuel',
    lastname: 'Berggren-Roos',
    fullname: 'Samuel Berggren-Roos',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 18951,

    _seed: '',
  },
  {
    id: '19840819-9290',
    firstname: 'Dan',
    lastname: 'Sjöberg',
    fullname: 'Dan Sjöberg',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19228,

    _seed: '',
  },
  {
    id: '19620317-3056',
    firstname: 'Yvonne',
    lastname: 'Vikström',
    fullname: 'Yvonne Vikström',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 20205,

    _seed: '',
  },
  {
    id: '19840920-9296',
    firstname: 'Amanda',
    lastname: 'Abdi',
    fullname: 'Amanda Abdi',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 17437,

    _seed: '',
  },
  {
    id: '19790330-9230',
    firstname: 'Jonny',
    lastname: 'Persson',
    fullname: 'Jonny Persson',
    fok: '0000000350',
    fok_short: 'FOK_CIVILFLYG(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 16815,

    _seed: '',
  },
  {
    id: 19591031,
    firstname: 'Charlotte',
    lastname: 'Sjödin',
    fullname: 'Charlotte Sjödin',
    fok: '0000000374',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 16550,

    _seed: '',
  },
  {
    id: '19540209-2638',
    firstname: 'David',
    lastname: 'Edlund-Ekström',
    fullname: 'David Edlund-Ekström',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19241,

    _seed: '',
  },
  {
    id: '20000125-2386',
    firstname: 'Göran',
    lastname: 'Hassan-Höglund',
    fullname: 'Göran Hassan-Höglund',
    fok: '0000000350',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 23697,

    _seed: '',
  },
  {
    id: '19441219-8154',
    firstname: 'Tord',
    lastname: 'Ivarsson',
    fullname: 'Tord Ivarsson',
    fok: '0000000350',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 15280,

    _seed: '',
  },
  {
    id: '19820120-9296',
    firstname: 'Catarina',
    lastname: 'Nyström-Ljung',
    fullname: 'Catarina Nyström-Ljung',
    fok: '0000000350',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 18662,

    _seed: '',
  },
  {
    id: '19971217-2395',
    firstname: 'Anna',
    lastname: 'Nyström-Sjöström',
    fullname: 'Anna Nyström-Sjöström',
    fok: '0000000350',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 6671,

    _seed: '',
  },
  {
    id: 19750330,
    firstname: 'Emma',
    lastname: 'Boström',
    fullname: 'Emma Boström',
    fok: '0000000350',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 10148,

    _seed: '',
  },
  {
    id: '19520712-2184',
    firstname: 'Håkan',
    lastname: 'Holm',
    fullname: 'Håkan Holm',
    fok: '0000000350',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 16997,

    _seed: '',
  },
  {
    id: '19450912-3412',
    firstname: 'Harriet',
    lastname: 'Friberg',
    fullname: 'Harriet Friberg',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 24527,

    _seed: '',
  },
  {
    id: '19671109-2681',
    firstname: 'Mattias',
    lastname: 'Hellström',
    fullname: 'Mattias Hellström',
    fok: '0000000374',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 22735,

    _seed: '',
  },
  {
    id: '19311104-9288',
    firstname: 'Filip',
    lastname: 'Abrahamsson',
    fullname: 'Filip Abrahamsson',
    fok: '0000000350',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 15197,

    _seed: '',
  },
  {
    id: '20021026-2382',
    firstname: 'Irma',
    lastname: 'Holmqvist',
    fullname: 'Irma Holmqvist',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 14517,

    _seed: '',
  },
  {
    id: '19911128-2399',
    firstname: 'Viola',
    lastname: 'Jacobsson',
    fullname: 'Viola Jacobsson',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 22088,

    _seed: '',
  },
  {
    id: '19710925-9288',
    firstname: 'Ellinor',
    lastname: 'Holmberg',
    fullname: 'Ellinor Holmberg',
    fok: '0000000350',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 24008,

    _seed: '',
  },
  {
    id: '19840731-9295',
    firstname: 'Elin',
    lastname: 'Åkesson',
    fullname: 'Elin Åkesson',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 23501,

    _seed: '',
  },
  {
    id: '19960510-2392',
    firstname: 'Christina',
    lastname: 'Jansson',
    fullname: 'Christina Jansson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 21558,

    _seed: '',
  },
  {
    id: '19471212-2235',
    firstname: 'Evelina',
    lastname: 'Hedström',
    fullname: 'Evelina Hedström',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 21973,

    _seed: '',
  },
  {
    id: '19550227-2684',
    firstname: 'Samuel',
    lastname: 'Hassan-Franzén',
    fullname: 'Samuel Hassan-Franzén',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 13825,

    _seed: '',
  },
  {
    id: '20021010-2380',
    firstname: 'Pia',
    lastname: 'Gustafsson',
    fullname: 'Pia Gustafsson',
    fok: '0000000350',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 29463,

    _seed: '',
  },
  {
    id: '19851003-9889',
    firstname: 'Rebecca',
    lastname: 'Sköld',
    fullname: 'Rebecca Sköld',
    fok: '0000000374',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 19571,

    _seed: '',
  },
  {
    id: '19901116-2386',
    firstname: 'Louise',
    lastname: 'Melin',
    fullname: 'Louise Melin',
    fok: '0000000350',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 22782,

    _seed: '',
  },
  {
    id: '19540918-2069',
    firstname: 'Robert',
    lastname: 'Östlund',
    fullname: 'Robert Östlund',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 13310,

    _seed: '',
  },
  {
    id: 19580909,
    firstname: 'Dan',
    lastname: 'Lind-Davidsson',
    fullname: 'Dan Lind-Davidsson',
    fok: '0000000374',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 19165,

    _seed: '',
  },
  {
    id: '19550227-2684',
    firstname: 'Kristian',
    lastname: 'Hellström',
    fullname: 'Kristian Hellström',
    fok: '0000000350',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 6074,

    _seed: '',
  },
  {
    id: '19831231-9281',
    firstname: 'Annelie',
    lastname: 'Lindh',
    fullname: 'Annelie Lindh',
    fok: '0000000374',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 10738,

    _seed: '',
  },
  {
    id: '19480826-2341',
    firstname: 'Ellinor',
    lastname: 'Lundström',
    fullname: 'Ellinor Lundström',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 5167,

    _seed: '',
  },
  {
    id: 19920603,
    firstname: 'Majken',
    lastname: 'Ali',
    fullname: 'Majken Ali',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 14968,

    _seed: '',
  },
  {
    id: '19800514-9284',
    firstname: 'Emelie',
    lastname: 'Mårtensson',
    fullname: 'Emelie Mårtensson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 10713,

    _seed: '',
  },
  {
    id: '19570227-2872',
    firstname: 'Svante',
    lastname: 'Stenberg',
    fullname: 'Svante Stenberg',
    fok: '0000000374',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 13173,

    _seed: '',
  },
  {
    id: '19991229-2399',
    firstname: 'Julia',
    lastname: 'Sjöström',
    fullname: 'Julia Sjöström',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 9876,

    _seed: '',
  },
  {
    id: '19580707-2813',
    firstname: 'Elena',
    lastname: 'Pålsson',
    fullname: 'Elena Pålsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 12604,

    _seed: '',
  },
  {
    id: '19820202-9289',
    firstname: 'Jan',
    lastname: 'Pettersson-Löfgren',
    fullname: 'Jan Pettersson-Löfgren',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 5707,

    _seed: '',
  },
  {
    id: '20021106-2385',
    firstname: 'Ted',
    lastname: 'Ström',
    fullname: 'Ted Ström',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 17045,

    _seed: '',
  },
  {
    id: '19810607-9257',
    firstname: 'Kaj',
    lastname: 'Söderlund-Hansen',
    fullname: 'Kaj Söderlund-Hansen',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 23104,

    _seed: '',
  },
  {
    id: '19430613-4760',
    firstname: 'Ingrid',
    lastname: 'Söderlund',
    fullname: 'Ingrid Söderlund',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 16536,

    _seed: '',
  },
  {
    id: '19821015-9284',
    firstname: 'Jim',
    lastname: 'Hedman',
    fullname: 'Jim Hedman',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 27093,

    _seed: '',
  },
  {
    id: '19660606-3193',
    firstname: 'Anton',
    lastname: 'Lind',
    fullname: 'Anton Lind',
    fok: '0000000350',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 21211,

    _seed: '',
  },
  {
    id: '19850611-9992',
    firstname: 'Paul',
    lastname: 'Höglund',
    fullname: 'Paul Höglund',
    fok: '0000000374',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 14977,

    _seed: '',
  },
  {
    id: '19911202-2380',
    firstname: 'Ida',
    lastname: 'Falk',
    fullname: 'Ida Falk',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 20851,

    _seed: '',
  },
  {
    id: '19850208-9884',
    firstname: 'Frank',
    lastname: 'Falk',
    fullname: 'Frank Falk',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 8646,

    _seed: '',
  },
  {
    id: '19630327-5793',
    firstname: 'Jonathan',
    lastname: 'Åberg',
    fullname: 'Jonathan Åberg',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 24766,

    _seed: '',
  },
  {
    id: '19660407-2766',
    firstname: 'Elsie',
    lastname: 'Edlund',
    fullname: 'Elsie Edlund',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 23687,

    _seed: '',
  },
  {
    id: '20000125-2386',
    firstname: 'Ingela',
    lastname: 'Lindström',
    fullname: 'Ingela Lindström',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19571,

    _seed: '',
  },
  {
    id: '19851003-9889',
    firstname: 'Alexander',
    lastname: 'Viklund',
    fullname: 'Alexander Viklund',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19971,

    _seed: '',
  },
  {
    id: '19550307-2042',
    firstname: 'Kent',
    lastname: 'Jönsson',
    fullname: 'Kent Jönsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 28920,

    _seed: '',
  },
  {
    id: '19550227-2684',
    firstname: 'Mikaela',
    lastname: 'Wiklund',
    fullname: 'Mikaela Wiklund',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 13745,

    _seed: '',
  },
  {
    id: '19901116-2386',
    firstname: 'Jacob',
    lastname: 'Jonasson-Nilsson',
    fullname: 'Jacob Jonasson-Nilsson',
    fok: '0000000374',
    fok_short: 'FOK_BEMANNING(A)',
    markup: 'Arbetare - Kollektivavtal Avtal för bemanningsföretag arbetare',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 11775,

    _seed: '',
  },
  {
    id: '19710925-9288',
    firstname: 'Tom',
    lastname: 'Pålsson',
    fullname: 'Tom Pålsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 20262,

    _seed: '',
  },
  {
    id: '19481004-2368',
    firstname: 'Wilhelm',
    lastname: 'Wiklund',
    fullname: 'Wilhelm Wiklund',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 17863,

    _seed: '',
  },
  {
    id: '20021028-2380',
    firstname: 'Mustafa',
    lastname: 'Bengtsson',
    fullname: 'Mustafa Bengtsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 21017,

    _seed: '',
  },
  {
    id: '19570508-2633',
    firstname: 'Jennifer',
    lastname: 'Jensen',
    fullname: 'Jennifer Jensen',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 17429,

    _seed: '',
  },
  {
    id: '19901104-2380',
    firstname: 'Jerry',
    lastname: 'Bergqvist',
    fullname: 'Jerry Bergqvist',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19619,

    _seed: '',
  },
  {
    id: '19490426-2153',
    firstname: 'Victoria',
    lastname: 'Larsson',
    fullname: 'Victoria Larsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19791,

    _seed: '',
  },
  {
    id: '19901019-2392',
    firstname: 'Viola',
    lastname: 'Blomqvist',
    fullname: 'Viola Blomqvist',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 20735,

    _seed: '',
  },
  {
    id: 19590226,
    firstname: 'Hannah',
    lastname: 'Sundström',
    fullname: 'Hannah Sundström',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19013,

    _seed: '',
  },
  {
    id: '19530519-2626',
    firstname: 'Fredrik',
    lastname: 'Skoglund',
    fullname: 'Fredrik Skoglund',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 28805,

    _seed: '',
  },
  {
    id: '19790618-9282',
    firstname: 'Andrea',
    lastname: 'Blom',
    fullname: 'Andrea Blom',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 14108,

    _seed: '',
  },
  {
    id: '19700612-1144',
    firstname: 'Khaled',
    lastname: 'Jakobsson',
    fullname: 'Khaled Jakobsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 28570,

    _seed: '',
  },
  {
    id: 19810607,
    firstname: 'Joanna',
    lastname: 'Dahlberg',
    fullname: 'Joanna Dahlberg',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 26216,

    _seed: '',
  },
  {
    id: '20000109-2386',
    firstname: 'Bodil',
    lastname: 'Göransson-Johnsson',
    fullname: 'Bodil Göransson-Johnsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 11678,

    _seed: '',
  },
  {
    id: '19710301-1032',
    firstname: 'Joakim',
    lastname: 'Öberg',
    fullname: 'Joakim Öberg',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 15121,

    _seed: '',
  },
  {
    id: '19971221-2399',
    firstname: 'Harriet',
    lastname: 'Möller',
    fullname: 'Harriet Möller',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 10552,

    _seed: '',
  },
  {
    id: '19590226-2806',
    firstname: 'Karl',
    lastname: 'Larsson',
    fullname: 'Karl Larsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 16524,

    _seed: '',
  },
  {
    id: '19550307-2042',
    firstname: 'Henrik',
    lastname: 'Hansson',
    fullname: 'Henrik Hansson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19447,

    _seed: '',
  },
  {
    id: '19810326-9299',
    firstname: 'Martina',
    lastname: 'Höglund',
    fullname: 'Martina Höglund',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 29113,

    _seed: '',
  },
  {
    id: '19840731-9295',
    firstname: 'Svante',
    lastname: 'Möller',
    fullname: 'Svante Möller',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 11997,

    _seed: '',
  },
  {
    id: '19921228-2397',
    firstname: 'Joacim',
    lastname: 'Forsberg',
    fullname: 'Joacim Forsberg',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 15166,

    _seed: '',
  },
  {
    id: '19540209-2638',
    firstname: 'Nelly',
    lastname: 'Wallin',
    fullname: 'Nelly Wallin',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 16225,

    _seed: '',
  },
  {
    id: '19450701-8820',
    firstname: 'Inez',
    lastname: 'Sundström',
    fullname: 'Inez Sundström',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 5527,

    _seed: '',
  },
  {
    id: '19790330-9230',
    firstname: 'Diana',
    lastname: 'Lundqvist-Johannesson',
    fullname: 'Diana Lundqvist-Johannesson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 16749,

    _seed: '',
  },
  {
    id: '19580909-2652',
    firstname: 'Lea',
    lastname: 'Oskarsson',
    fullname: 'Lea Oskarsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 11663,

    _seed: '',
  },
  {
    id: '19490712-1794',
    firstname: 'Olov',
    lastname: 'Molin',
    fullname: 'Olov Molin',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 25826,

    _seed: '',
  },
  {
    id: '19820120-9296',
    firstname: 'Isabell',
    lastname: 'Lund-Lilja',
    fullname: 'Isabell Lund-Lilja',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 8472,

    _seed: '',
  },
  {
    id: '19490519-2334',
    firstname: 'Bodil',
    lastname: 'Strandberg',
    fullname: 'Bodil Strandberg',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 10311,

    _seed: '',
  },
  {
    id: '19620317-3056',
    firstname: 'Markus',
    lastname: 'Fransson',
    fullname: 'Markus Fransson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 27831,

    _seed: '',
  },
  {
    id: '19490214-2696',
    firstname: 'Jörgen',
    lastname: 'Henriksson',
    fullname: 'Jörgen Henriksson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 23623,

    _seed: '',
  },
  {
    id: '19270401-9229',
    firstname: 'Svante',
    lastname: 'Dahlberg',
    fullname: 'Svante Dahlberg',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 23499,

    _seed: '',
  },
  {
    id: '19531103-2121',
    firstname: 'Yvonne',
    lastname: 'Holmgren',
    fullname: 'Yvonne Holmgren',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 12176,

    _seed: '',
  },
  {
    id: '19680522-9272',
    firstname: 'Christian',
    lastname: 'Ek',
    fullname: 'Christian Ek',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 5372,

    _seed: '',
  },
  {
    id: '19700612-1144',
    firstname: 'Rebecka',
    lastname: 'Palm',
    fullname: 'Rebecka Palm',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 27818,

    _seed: '',
  },
  {
    id: '19491013-2507',
    firstname: 'Wilhelm',
    lastname: 'Ottosson',
    fullname: 'Wilhelm Ottosson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 8126,

    _seed: '',
  },
  {
    id: '19801210-9289',
    firstname: 'Gustav',
    lastname: 'Holmqvist',
    fullname: 'Gustav Holmqvist',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 13974,

    _seed: '',
  },
  {
    id: '19990106-2381',
    firstname: 'Amina',
    lastname: 'Söderström',
    fullname: 'Amina Söderström',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 28284,

    _seed: '',
  },
  {
    id: '19831231-9281',
    firstname: 'Ruth',
    lastname: 'Henriksson',
    fullname: 'Ruth Henriksson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 17571,

    _seed: '',
  },
  {
    id: '19580909-2652',
    firstname: 'Patrick',
    lastname: 'Ali',
    fullname: 'Patrick Ali',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 26020,

    _seed: '',
  },
  {
    id: '19710925-9288',
    firstname: 'Elsie',
    lastname: 'Jacobsson',
    fullname: 'Elsie Jacobsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 12060,

    _seed: '',
  },
  {
    id: '19490712-1794',
    firstname: 'Irene',
    lastname: 'Henriksson',
    fullname: 'Irene Henriksson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 14816,

    _seed: '',
  },
  {
    id: '19960503-2383',
    firstname: 'Björn',
    lastname: 'Carlsson',
    fullname: 'Björn Carlsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 28824,

    _seed: '',
  },
  {
    id: '19650201-3755',
    firstname: 'Mattias',
    lastname: 'Henriksson',
    fullname: 'Mattias Henriksson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 22422,

    _seed: '',
  },
  {
    id: '19350127-7697',
    firstname: 'Sanna',
    lastname: 'Knutsson-Jönsson',
    fullname: 'Sanna Knutsson-Jönsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 20111,

    _seed: '',
  },
  {
    id: '19570227-2872',
    firstname: 'Tony',
    lastname: 'Hagström',
    fullname: 'Tony Hagström',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 16962,

    _seed: '',
  },
  {
    id: '19431209-5450',
    firstname: 'Ola',
    lastname: 'Strömberg',
    fullname: 'Ola Strömberg',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 10135,

    _seed: '',
  },
  {
    id: '19570508-2633',
    firstname: 'Yvonne',
    lastname: 'Bergman',
    fullname: 'Yvonne Bergman',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 14822,

    _seed: '',
  },
  {
    id: '19821015-9284',
    firstname: 'Bo',
    lastname: 'Malmberg',
    fullname: 'Bo Malmberg',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 14167,

    _seed: '',
  },
  {
    id: '19870312-2385',
    firstname: 'Zahra',
    lastname: 'Sandström',
    fullname: 'Zahra Sandström',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 9332,

    _seed: '',
  },
  {
    id: 20011225,
    firstname: 'James',
    lastname: 'Ottosson',
    fullname: 'James Ottosson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 26423,

    _seed: '',
  },
  {
    id: '19680522-9272',
    firstname: 'Beatrice',
    lastname: 'Nordström',
    fullname: 'Beatrice Nordström',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 12052,

    _seed: '',
  },
  {
    id: '19960408-2397',
    firstname: 'Leif',
    lastname: 'Malm',
    fullname: 'Leif Malm',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 23061,

    _seed: '',
  },
  {
    id: 19920603,
    firstname: 'Tor',
    lastname: 'Malm',
    fullname: 'Tor Malm',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 16053,

    _seed: '',
  },
  {
    id: '19570508-2633',
    firstname: 'Kristin',
    lastname: 'Dahlberg',
    fullname: 'Kristin Dahlberg',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 15506,

    _seed: '',
  },
  {
    id: '19911202-2380',
    firstname: 'Helena',
    lastname: 'Franzén',
    fullname: 'Helena Franzén',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 5135,

    _seed: '',
  },
  {
    id: '19840819-9290',
    firstname: 'Annelie',
    lastname: 'Lund',
    fullname: 'Annelie Lund',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 27892,

    _seed: '',
  },
  {
    id: '19630327-5793',
    firstname: 'Susanna',
    lastname: 'Petersson',
    fullname: 'Susanna Petersson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 8136,

    _seed: '',
  },
  {
    id: '19540209-2638',
    firstname: 'Diana',
    lastname: 'Nguyen',
    fullname: 'Diana Nguyen',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 7490,

    _seed: '',
  },
  {
    id: '19790618-9282',
    firstname: 'Joanna',
    lastname: 'Jensen',
    fullname: 'Joanna Jensen',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 18216,

    _seed: '',
  },
  {
    id: '19901107-2387',
    firstname: 'Mårten',
    lastname: 'Hagström',
    fullname: 'Mårten Hagström',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 7360,

    _seed: '',
  },
  {
    id: '19560618-2748',
    firstname: 'Susanne',
    lastname: 'Vikström',
    fullname: 'Susanne Vikström',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 10826,

    _seed: '',
  },
  {
    id: '19441219-8154',
    firstname: 'Jens',
    lastname: 'Åkesson',
    fullname: 'Jens Åkesson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19922,

    _seed: '',
  },
  {
    id: '19470122-2798',
    firstname: 'Harry',
    lastname: 'Höglund',
    fullname: 'Harry Höglund',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 27524,

    _seed: '',
  },
  {
    id: '19891027-2395',
    firstname: 'Rikard',
    lastname: 'Mohamed',
    fullname: 'Rikard Mohamed',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 20567,

    _seed: '',
  },
  {
    id: '19940104-2388',
    firstname: 'Urban',
    lastname: 'Bergqvist',
    fullname: 'Urban Bergqvist',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 23801,

    _seed: '',
  },
  {
    id: '19501101-2365',
    firstname: 'Kristin',
    lastname: 'Samuelsson',
    fullname: 'Kristin Samuelsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 25261,

    _seed: '',
  },
  {
    id: '19901025-2386',
    firstname: 'Anna',
    lastname: 'Jacobsson',
    fullname: 'Anna Jacobsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 15230,

    _seed: '',
  },
  {
    id: '20050912-2388',
    firstname: 'Anna-Lena',
    lastname: 'Mohammed',
    fullname: 'Anna-Lena Mohammed',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 29000,

    _seed: '',
  },
  {
    id: '19480826-2341',
    firstname: 'Josef',
    lastname: 'Lindgren',
    fullname: 'Josef Lindgren',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 19157,

    _seed: '',
  },
  {
    id: '19680227-9296',
    firstname: 'Kristin',
    lastname: 'Löfgren',
    fullname: 'Kristin Löfgren',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 22347,

    _seed: '',
  },
  {
    id: '19580607-3077',
    firstname: 'Göran',
    lastname: 'Månsson',
    fullname: 'Göran Månsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 14171,

    _seed: '',
  },
  {
    id: '19350127-7697',
    firstname: 'Christian',
    lastname: 'Nordin',
    fullname: 'Christian Nordin',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 29257,

    _seed: '',
  },
  {
    id: '19311231-6710',
    firstname: 'Ibrahim',
    lastname: 'Sjödin',
    fullname: 'Ibrahim Sjödin',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 12079,

    _seed: '',
  },
  {
    id: '19950605-2399',
    firstname: 'Krister',
    lastname: 'Larsson',
    fullname: 'Krister Larsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 26114,

    _seed: '',
  },
  {
    id: '19460304-7327',
    firstname: 'Helén',
    lastname: 'Ibrahim',
    fullname: 'Helén Ibrahim',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 14952,

    _seed: '',
  },
  {
    id: '19710301-1032',
    firstname: 'André',
    lastname: 'Hassan',
    fullname: 'André Hassan',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 26227,

    _seed: '',
  },
  {
    id: '20011217-2382',
    firstname: 'Conny',
    lastname: 'Roos',
    fullname: 'Conny Roos',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon piggy',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 13614,

    _seed: '',
  },
  {
    id: '19881003-2386',
    firstname: 'Marita',
    lastname: 'Skoglund-Månsson',
    fullname: 'Marita Skoglund-Månsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 11668,

    _seed: '',
  },
  {
    id: '19700612-1144',
    firstname: 'Maryam',
    lastname: 'Linder',
    fullname: 'Maryam Linder',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 7542,

    _seed: '',
  },
  {
    id: '19981224-2395',
    firstname: 'Ivar',
    lastname: 'Börjesson',
    fullname: 'Ivar Börjesson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 6738,

    _seed: '',
  },
  {
    id: '19640713-3252',
    firstname: 'Thi',
    lastname: 'Carlsson',
    fullname: 'Thi Carlsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Show',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 29506,

    _seed: '',
  },
  {
    id: '19870410-2386',
    firstname: 'Irma',
    lastname: 'Hagström',
    fullname: 'Irma Hagström',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay active',
    pay: 10263,

    _seed: '',
  },
  {
    id: '19820705-9299',
    firstname: 'Jennifer',
    lastname: 'Lindqvist-Lindblom',
    fullname: 'Jennifer Lindqvist-Lindblom',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 17445,

    _seed: '',
  },
  {
    id: '19931223-2391',
    firstname: 'Joanna',
    lastname: 'Lindqvist',
    fullname: 'Joanna Lindqvist',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon bell',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 21117,

    _seed: '',
  },
  {
    id: '20011226-2399',
    firstname: 'Julia',
    lastname: 'Abrahamsson',
    fullname: 'Julia Abrahamsson',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon continue',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 29429,

    _seed: '',
  },
  {
    id: '19480930-1551',
    firstname: 'Niklas',
    lastname: 'Nguyen',
    fullname: 'Niklas Nguyen',
    fok: '0000000374',
    fok_short: 'FOK_HEMSERVICE(A)',
    markup: 'Arbetare - Kollektivavtal Hemserviceföretag',
    exception: '/Hide',
    ex_kind: 'Size=Desktop, Type=Cell, Content=Markup icon world',
    attribute: 'Size=Desktop, Type=Cell, Content=Attributable pay',
    pay: 22141,

    _seed: '',
  },
];
